import { memo } from 'react';
import { Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from '@library';
import type { ConfirmationComponent } from '../../../types/customStoryblokComponents';
import { useStoryblokContext } from '../../StoryblokFormContext';

interface ConfirmationProps {
    params: ConfirmationComponent;
}

const Confirmation = ({ params: { name } }: ConfirmationProps) => {
    const { readonly } = useStoryblokContext();

    if (readonly) {
        return null;
    }

    return (
        <Controller
            name="confirmation"
            render={({ field }) => (
                <Checkbox
                    checked={field.value}
                    name={name}
                    onChange={newValue => {
                        field.onChange(newValue);
                    }}
                    data-test-class={name}
                >
                    <FormattedMessage id="accept the terms and conditions" />
                </Checkbox>
            )}
            rules={{ required: true }}
        />
    );
};

export default memo(Confirmation);
